module.exports = __webpack_public_path__ + "img/ltc.cdae0850.svg";